import createPalette from '@material-ui/core/styles/createPalette';

const muiPalette = createPalette({
  primary: { main: '#17936F' },
  error: { main: '#B51C1C' },
});

export default muiPalette;
